/** True when HTML is being captured by react-snap / headless Chromium. */
export function isPrerenderCrawl() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return /ReactSnap/i.test(ua) || /HeadlessChrome/i.test(ua);
}
